// extracted by mini-css-extract-plugin
module.exports = {"search-box":"styles_search-box__aevfx","home-banners":"styles_home-banners___cb_P"};